import { useState } from 'react';
import { ReactComponent as LangIcon } from '../../../assets/icons/lang.svg';
import { useTheme } from '../../../hooks/useTheme';
import { LanguagePicker } from '../../LanguagePicker';

export const LanguageSwitch = () => {
    const [opened, setOpened] = useState(false);
    const theme = useTheme();
    return (
        <div className="flex space-x-2 items-center">
            <button
                onClick={() => setOpened(true)}
                className="p-0 w-[42px] h-[42px] text-brand-iconColor bg-white rounded-full flex justify-center items-center text-bran"
            >
                <LangIcon className="fill-current" style={{ fill: theme.primaryColor }} />
            </button>
            <LanguagePicker
                opened={opened}
                onClose={() => setOpened(false)}
                onSelect={() => setOpened(false)}
            />
        </div>
    );
};
